import ApiService from './api-service'

class Feed extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        // this.put = null
        // this.delete = null
    }

    get(options) {
      options = options || {};
      return super.get('/feed', options)
    }

    getHidden(options) {
      options = options || {};
      return super.get('/feed/hidden', options)
    }

    list(options) {
      options = options || {};
      return super.get('/feed', options)
    }

    listV2(options) {
      options = options || {};
      return super.get('/v2/feed', options)
    }

    listV3(options) {
      options = options || {};
      return super.get('/v3/feed', options)
    }

    listV4(options) {
      options = options || {};
      return super.get('/v4/feed', options)
    }

    listHidden(options) {
      options = options || {};
      return super.get('/feed/hidden', options)
    }


    clear() {
      return super.clear('/feed')
    }
}

const _Feed = new Feed()
export default _Feed
